let en = {
  Content: "Committed to the innovation of blockchain +",
  ContentSub: "SealSC is a middleware cloud platform that links the Internet and blockchain networks and provides Oracle services through its own public chain. The aim is to enable users/enterprises to build DApps without barriers, interoperate with current public chains, and realize business scenarios such as cross-chain convergence, value circulation and data exchange.",
}

let zh =  {
  Content: '致力于区块链+ 领域的开拓与创新',
  ContentSub: 'SealSC是链接互联网和区块链网络的中间件云平台，并通过自有公链提供Oracle服务。旨在实现让用户/企业无门槛搭建DApp，互通目前各大公链，实现跨链融合、价值流通和数据交换等业务场景。',
}

let name = 'Home'

export default {
  name,
  en,
  zh
}